/* eslint-disable react/forbid-dom-props */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from './spzaComponent';
import { InternalLink } from './internalLink';
import * as DetailUtils from './../utils/detailUtils';
export class BreadcrumbUrl extends SpzaComponent {
    buildGalleryLink(title, href) {
        return /*#__PURE__*/ _jsx(InternalLink, {
            href: href,
            role: "link",
            className: 'c-button goBackButton',
            additionalCommand: ()=>{
                DetailUtils.generateBreadcrumbPayloadAndLogTelemetry('Apps');
            },
            accEnabled: true,
            "aria-label": `${title} link breadcrumb region`,
            "aria-current": "page",
            children: title
        });
    }
    renderImpl() {
        const { hideBreadcrumbUrl } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx("div", {
                className: "navigationBar",
                id: "maincontent",
                children: !hideBreadcrumbUrl && /*#__PURE__*/ _jsx("nav", {
                    className: "breadcrumb",
                    "aria-label": "breadcrumbs",
                    children: this.props.linksList.map((link, index)=>{
                        const title = this.context.loc(link.locKey);
                        const key = `breadcrumb-${link.href}-${title}`;
                        link.href = link.href || this.props.href;
                        if (index === this.props.linksList.length - 1) {
                            return /*#__PURE__*/ _jsx("div", {
                                className: "appTabButton",
                                "aria-label": "breadcrumb",
                                "aria-current": "page",
                                children: this.context.loc(link.locKey)
                            }, key);
                        }
                        return /*#__PURE__*/ _jsxs("div", {
                            className: "breadcrumbItem",
                            children: [
                                this.buildGalleryLink(title, link.href),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "c-glyph"
                                })
                            ]
                        }, key);
                    })
                })
            })
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0);
    }
}
BreadcrumbUrl.contextTypes = {
    loc: PropTypes.func
};
